import { DevToolsEmptyState } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsEmptyState';
import { DebugEventRow } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugEventRow';
import type { DebugRecordEventsProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordEvents/index.types';
import {
  SURFACE,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React, { useCallback, useState } from 'react';

/**
 * DebugRecordEvents - The events captured for one leg
 *
 * A frozen echo of the Events tab:
 */
export const DebugRecordEvents: React.FC<DebugRecordEventsProps> = ({
  events,
}) => {
  const [openIds, setOpenIds] = useState<Record<string, boolean>>({});

  const toggle = useCallback((id: string) => {
    setOpenIds((current) => ({ ...current, [id]: !current[id] }));
  }, []);

  if (!events || events.length === 0) {
    return (
      <DevToolsEmptyState
        title="No events captured"
        body="No event named this call id, and nothing unattributed fell between its start and its end."
      />
    );
  }

  return (
    <div className={SURFACE.card}>
      {events.map((event) => (
        <DebugEventRow
          key={event.id}
          event={event}
          isOpen={Boolean(openIds[event.id])}
          onToggle={() => toggle(event.id)}
        />
      ))}
    </div>
  );
};
